
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/aldagram",
      function () {
        return require("private-next-pages/cases/aldagram/index.tsx");
      }
    ]);
  